/**
 * Vendor-defined walker/trainer packages (client change, 9 Oct 2026).
 * Mirrors backend/src/modules/service-package/service-package.service.ts serializer.
 */
export type PackageModule = 'WALKER' | 'TRAINER';

/** Package lengths the client asked for. */
export const PACKAGE_DURATIONS = [7, 15, 30] as const;
export type PackageDuration = (typeof PACKAGE_DURATIONS)[number];

export interface ServicePackage {
  id: string;
  vendor_profile_id: string;
  service_id: string;
  service_name: string;
  session_minutes: number | null;
  module_type: PackageModule;
  name: string;
  description: string | null;
  duration_days: number;
  sessions_count: number;
  /** How many weekdays the customer must pick (e.g. 3 → Mon-Wed-Fri or Tue-Thu-Sat). */
  sessions_per_week: number;
  price_inr: string;
  /** Strike-off: service price × sessions; null when the package isn't cheaper (Nov 2026). */
  compare_at_price_inr: string | null;
  discount_pct: number | null;
  is_active: boolean;
}

export interface CreateServicePackageInput {
  service_id: string;
  name: string;
  description?: string;
  duration_days: PackageDuration;
  sessions_count: number;
  price_inr: number;
  is_active?: boolean;
}

export type UpdateServicePackageInput = Partial<Omit<CreateServicePackageInput, 'service_id' | 'description'>> & {
  description?: string | null;
};

/** Same rule as the backend: ceil(sessions * 7 / days), capped at 7. */
export function sessions_per_week(p: { sessions_count: number; duration_days: number }): number {
  return Math.min(7, Math.ceil((p.sessions_count * 7) / p.duration_days));
}
